<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item first-item">
      <a class="d-flex align-items-center text-decoration-none cursor-pointer" (click)="goToHome()">
        <span class="material-symbols-outlined me-1">
          home
        </span>
        <span> Home</span>
      </a>
    </li>
    @if (list.length > 0) {
      @for (item of list; track item.text + item.url; let i = $index; let last = $last) {
        @if (!last) {
          <li class="breadcrumb-item">
            <a class="curson-pointer" (click)="naviteURL(item)">{{item.text}}</a>
          </li>
        } @else {
          <li class="breadcrumb-item active" aria-current="page">{{item.text}}</li>
        }
      }
    } @else {
      <!-- Placeholder invisible: reserva el mismo alto que el ícono ">" + texto
           de las pantallas que sí tienen segundo nivel, para que el header no
           salte de tamaño al navegar entre módulos con y sin breadcrumb. -->
      <li class="breadcrumb-item placeholder-item" aria-hidden="true">&nbsp;</li>
    }

  </ol>
</nav>
